var map = {
	"./Wolt.jpg": "34ac",
	"./Wolt2.jpg": "9b40",
	"./Wolt3.png": "58c3",
	"./aikasa.png": "2a1b",
	"./android-app-icon.jpg": "a478",
	"./apple-app-store-icon.png": "5a7c",
	"./boltfood.jpg": "be53",
	"./cash_register.png": "6613",
	"./cash_register_4.jpg": "dd3d",
	"./glovo.jpg": "52b6",
	"./glovo2.jpeg": "dc28",
	"./kava.jpg": "3fd6",
	"./keyboardLayouts/aduroHr": "3732",
	"./keyboardLayouts/aduroHr.js": "3732",
	"./logo-1x.png": "1999",
	"./logo-AI-kasa-negativ.png": "ba8b",
	"./logo-AI-kasa-negativ.svg": "5e5f",
	"./logo-AI-kasa.svg": "2f66",
	"./logo-screen.png": "99cc",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./logo1.png": "534f",
	"./logos/blagajna-popcornpay.com.hr.png": "8f7c",
	"./logos/blagajna.online.png": "a1c4",
	"./logos/demokasa.vestok.hr.png": "401c",
	"./logos/kasa.vestok.hr.png": "e109",
	"./no-item-small.jpg": "3250",
	"./no-item.jpg": "d113",
	"./ostali.jpg": "f157",
	"./pivo.jpg": "b75c",
	"./selling_point_cover.jpg": "ecb6",
	"./selling_point_cover_bck.jpg": "82d2",
	"./sokovi.jpg": "ac40",
	"./styles/main.css": "927c",
	"./styles/oskStyles.css": "4243",
	"./templates/defaultTemplateConfiguration": "0369",
	"./templates/defaultTemplateConfiguration.json": "0369",
	"./text.png": "712e",
	"./unknown_profile.jpg": "2e9f",
	"./unknown_profile_bck.jpg": "d7b2",
	"./vino.jpg": "c5c0",
	"./viski.jpeg": "1fbf",
	"./voda.jpeg": "fbd0",
	"./voda.jpg": "50a2",
	"./wolt4.jpg": "f171"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";